import React from 'react';
import { Routes, Route, Navigate, createRoutesFromElements, unstable_RelativeRoute as RelativeRoute } from 'react-router-dom';

// Importando páginas
import Calculator from '../components/Calculator/Calculator';
import Guide from '../components/pages/Guide';
import About from '../components/pages/About';
import PrivacyPolicy from '../components/pages/PrivacyPolicy';
import Terms from '../components/pages/Terms';
import ExportData from '../components/Export/ExportData';

/**
 * Componente de rotas da aplicação
 * Implementa URLs amigáveis para SEO
 */
const AppRoutes = () => {
  return (
    <Routes
      // Adicionando flags futuras para compatibilidade com React Router v7
      future={{ v7_startTransition: true, v7_relativeSplitPath: true }}
    >
      <Route path="/" element={<Calculator />} />
      <Route path="/calculadora" element={<Calculator />} />
      <Route path="/cenarios" element={<Calculator initialStep="scenarios" />} />
      <Route path="/marcos" element={<Calculator initialStep="milestones" />} />
      <Route path="/aposentadoria" element={<Calculator initialStep="retirement" />} />
      <Route path="/exportar" element={<ExportData />} />
      <Route path="/guia" element={<Guide />} />
      <Route path="/sobre" element={<About />} />
      <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
      <Route path="/termos-de-uso" element={<Terms />} />
      
      {/* Rota de fallback para páginas não encontradas */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
